module.exports = __webpack_public_path__ + "img/discover-m.bf53688f.png";